import type { RaiseBoardFacet, RaiseBoardFacets } from "@/api/raise-board-api";
import { GICSSubIndustries } from "@/lib/utils";

export interface FilterOption {
  label: string;
  value: string;
}

/**
 * Turn the server's facet counts into dropdown options for the board filters.
 *
 * Stage and country arrive ready to show. Industries arrive as GICS
 * sub-industry codes, because the code→name table ships in this bundle rather
 * than from the API — a code with no local entry is dropped rather than offered
 * as a bare 10-digit number nobody can act on.
 */
export function buildFilterOptions(facets?: RaiseBoardFacets): {
  stages: FilterOption[];
  countries: FilterOption[];
  industries: FilterOption[];
} {
  const withCount = (entries: RaiseBoardFacet[] = []) =>
    entries.map((entry) => ({
      label: `${entry.value} (${entry.count})`,
      value: entry.value,
    }));

  return {
    stages: withCount(facets?.stages),
    countries: withCount(facets?.countries),
    industries: (facets?.industries ?? []).flatMap((entry) => {
      const name = GICSSubIndustries.find((si) => si.code === entry.value)?.name;
      return name
        ? [{ label: `${name} (${entry.count})`, value: entry.value }]
        : [];
    }),
  };
}
